import * as React from 'react';
import {
    Button,
    Grid, InputAdornment,
    TextField
} from "@mui/material";
import {
    ArrowBackIos, ArrowForwardIos, Mail
} from "@mui/icons-material";
import Body from "../global/Body";
import reducer from "../../store/request";
import withReducer from "../../store/withReducer";
import {memo, useState} from "react";
import {selectRequestState, setItem, setStep} from "../../store/request/stateSlice";
import {useDispatch, useSelector} from "react-redux";
import Api from "../../inc/Api";
import Typography from "@mui/material/Typography";
import Toast from "../../inc/Toast";

function Step3Recover() {

    const {item} = useSelector(selectRequestState);
    const dispatch = useDispatch();
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    function recover() {

        setLoading(true);
        setError(null);
        Api.post('/admin/login/recover', {
            username : item.client.email,
            id_widget: item.id_widget,
        }, rsp => {
            if (rsp.ok) {

                Toast.success(rsp.msg);
                dispatch(setStep('3_login'));


            } else {
                setLoading(false);
                setError(rsp.msg);
            }
        });

    }

    return (
        <Body title="Recuperar contraseña" onSubmit={recover}>

            <Grid container spacing={3}>

                <Grid xs={12} item>

                    <Typography color="secondary">
                        Introduzca su dirección de correo electrónico. Recibirá los detalles de la recuperación por
                        correo electrónico.
                    </Typography>

                </Grid>

                <Grid xs={12} md={6} item>

                    <TextField
                        label="Correo electrónico"
                        value={item.client.email}
                        onChange={e => dispatch(setItem({
                            client: {
                                ...item.client,
                                email: e.target.value,
                            }
                        }))}
                        InputProps={{
                            endAdornment: (
                                <InputAdornment position="end">
                                    <Mail color="primary"/>
                                </InputAdornment>
                            ),
                        }}
                        error={!!error}
                        helperText={error}/>

                </Grid>

                <Grid md={6} item display={{xs: 'none', md: 'block'}}/>
                <Grid md={6} item display={{xs: 'none', md: 'block'}}/>

                <Grid xs={6} md={3} item>

                    <Button
                        variant="contained"
                        startIcon={<ArrowBackIos/>}
                        onClick={() => {
                            dispatch(setStep('3_login'));
                        }}
                        color="secondary"
                        disabled={loading}
                        fullWidth>
                        Volver
                    </Button>

                </Grid>

                <Grid xs={6} md={3} item>

                    <Button
                        variant="contained"
                        endIcon={!loading && <ArrowForwardIos/>}
                        type="submit"
                        disabled={!item.client.email || loading}
                        fullWidth>
                        {loading ? 'Verificando...' : 'Siguiente'}
                    </Button>

                </Grid>

            </Grid>

        </Body>
    );
}

export default withReducer('request', reducer)(memo(Step3Recover));